import Footer, { FooterProps } from '@components/shared/Footer';
import { MenuDropdown } from '@components/shared/navbar/MenuDropdown';
import Navbar, { NavbarProps } from '@components/shared/navbar/Navbar';
import { faEllipsisV } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// TODO: FloatingActionButton will be renamed to Fab in later version of kit
import { Box, BoxProps, Fab } from '@mui/material';
import { useContext, useState } from 'react';
import Page, { PagePropsType } from './Page';
import {
  HelpModal,
  HelpModalProps,
} from '@components/shared/navbar/help/HelpModal';
import { SettingsContext } from '@contexts/SettingsContext';
import { useImpersonation } from '@components/Dashboard/hooks/useImpersonation';

type PageWithNavbarProps = {
  helpModalDefaultType?: HelpModalProps['defaultType'];
  boxProps?: BoxProps;
  navbarProps?: Omit<NavbarProps, 'onHelpModalToggle'>;
  footerProps?: FooterProps;
} & PagePropsType;

const PageWithNavbar = (props: PageWithNavbarProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);
  const { hubMode } = useContext(SettingsContext);
  useImpersonation();

  const handleHelpModalToggle = () => setIsHelpModalOpen(!isHelpModalOpen);
  const showNavbar = !hubMode;

  return (
    <>
      <HelpModal
        isOpen={isHelpModalOpen}
        closeModal={() => setIsHelpModalOpen(false)}
        defaultType={props.helpModalDefaultType}
      />
      {showNavbar ? (
        <Navbar
          {...props.navbarProps}
          onHelpModalToggle={handleHelpModalToggle}
        />
      ) : null}
      {hubMode ? (
        <>
          <Fab
            color="primary"
            sx={{
              position: 'fixed',
              margin: 0,
              top: 'auto',
              right: 20,
              bottom: 20,
              zIndex: 500,
            }}
            onClick={e => setAnchorEl(e.currentTarget)}
          >
            <FontAwesomeIcon size="2x" icon={faEllipsisV} />
          </Fab>
          <MenuDropdown
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
            sx={{}}
            transformOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
            onHelpModalToggle={handleHelpModalToggle}
          />
        </>
      ) : null}
      <Box className="nd-content" {...props.boxProps}>
        <Page {...props} />
      </Box>
      <Footer {...props.footerProps} />
    </>
  );
};

export default PageWithNavbar;
